export const validEmail = new RegExp('^[a-zA-Z0-9._:$!%-]+@[a-zA-Z0-9.-]+.[a-zA-Z]$');
export const validPassword = new RegExp('^(?=.*?[A-Za-z])(?=.*?[0-9]).{6,}$');
export const empty = new RegExp('^.{0}$');
export const zero = new RegExp('^[1-9][0-9]*$');
export const validRussianEmail = /(\.ru|\.рф|@vk\.com)$/i;
